import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles, Wand2, FileText, Languages, PenLine } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const ROTATING_PHRASES = [
  "ohne Stress.",
  "für E-Mails.",
  "für Bewerbungen.",
  "für Behördenschreiben.",
  "für Ihr Team.",
];

const FIVE_TOOLS = [
  { icon: Sparkles,  label: "Korrigieren" },
  { icon: Wand2,     label: "Verbessern" },
  { icon: PenLine,   label: "Verfassen" },
  { icon: FileText,  label: "Zusammenfassen" },
  { icon: Languages, label: "Auf Deutsch" },
];

export function HeroSection() {
  const [phraseIndex, setPhraseIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPhraseIndex((i) => (i + 1) % ROTATING_PHRASES.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative pt-16 pb-10 md:pt-24 md:pb-16" aria-labelledby="hero-heading">
      <div className="container relative px-4">
        <div className="mx-auto max-w-2xl text-center">
          {/* Trust badge */}
          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-border/50 bg-muted/40 px-3 py-1 text-[11px] text-muted-foreground">
            <span className="h-1.5 w-1.5 rounded-full bg-primary" />
            DSGVO-konform · DACH-optimiert
          </div>

          <h1
            id="hero-heading"
            className="text-3xl font-semibold tracking-tight text-foreground sm:text-5xl md:text-6xl leading-[1.1]"
          >
            Professionelles Deutsch –{" "}
            <span className="block sm:inline h-[1.2em] relative">
              <AnimatePresence mode="wait">
                <motion.span
                  key={phraseIndex}
                  initial={{ opacity: 0, y: 12 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -12 }}
                  transition={{ duration: 0.35 }}
                  className="text-primary inline-block"
                >
                  {ROTATING_PHRASES[phraseIndex]}
                </motion.span>
              </AnimatePresence>
            </span>
          </h1>

          <p className="mt-5 text-base text-muted-foreground md:text-lg max-w-xl mx-auto leading-relaxed">
            Ein Eingabefeld, fünf Werkzeuge — die KI erkennt automatisch, was Sie brauchen.
          </p>

          {/* 5 tool chips — visual hint of what's inside */}
          <ul className="mt-7 flex flex-wrap items-center justify-center gap-1.5">
            {FIVE_TOOLS.map(({ icon: Icon, label }) => (
              <li
                key={label}
                className="inline-flex items-center gap-1.5 rounded-md border border-border/50 bg-card/60 px-2.5 py-1 text-[12px] text-muted-foreground"
              >
                <Icon className="h-3.5 w-3.5 text-primary" />
                {label}
              </li>
            ))}
          </ul>

          {/* Single CTA */}
          <div className="mt-8 flex flex-col items-center gap-2">
            <Link to="/register" className="w-full sm:w-auto">
              <Button size="lg" className="w-full sm:w-auto h-11 px-6 text-sm sm:text-base group">
                Kostenlos starten — 7 Tage Pro testen
                <ArrowRight className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </Button>
            </Link>
            <span className="text-[11px] text-muted-foreground">Keine Kreditkarte · Jederzeit kündbar</span>
          </div>
        </div>
      </div>
    </section>
  );
}
